import React from 'react';
import { useNavigate } from "react-router-dom";
import './TestTimePageStyle.css';

function TestTimePage() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/Login");
    };

    // aktuelles Jahr dynamisch ermitteln
    const currentYear = new Date().getFullYear();

    return (
        <div className="container">
            <div className="header">
                <h1>Willkommen bei RescueOfficer!</h1>
            </div>
            <div className="notice">
                <h2>Kostenloser Probezeitraum</h2>
                <p>Wir freuen uns, Ihnen mitteilen zu können, dass Sie RescueOfficer jetzt 31 Tage kostenlos ausprobieren können! Nutzen Sie diese Gelegenheit, um alle Funktionen unseres Dienstes ohne Verpflichtungen zu testen.</p>
                <p>Nach den 31 Tagen ist eine Bezahlung erforderlich, um weiterhin Zugang zu unserem Service zu erhalten.</p>
                <p>Wir sind überzeugt, dass RescueOfficer Ihnen wertvolle Dienste leisten wird, und hoffen, dass Sie von unserem Angebot profitieren werden!</p>
            </div>
            <div className="footer">
                <p>&copy; {currentYear} MBSoftwareSolutions. Alle Rechte vorbehalten.</p>
            </div>
            <div className="inputContainer">
                <input
                    className="inputButton"
                    type="button"
                    onClick={handleClick}
                    value={"Verstanden"} />
            </div>
        </div>
    );
}

export default TestTimePage;